import { Box } from '@homebot/shared-ui-swashbuckle'
import { LTCV_FOR_PMI_REMOVAL } from '../pmiConstants'
import { CanRemovePmiDetails } from './CanRemovePmiDetails'
import { CannotRemovePmiDetails } from './CannotRemovePmiDetails'

export interface PmiDetailsTextProps {
  ltcvPercent: number
}

export const PmiDetails = ({ ltcvPercent }: PmiDetailsTextProps) => {
  const canRemovePmi = ltcvPercent <= LTCV_FOR_PMI_REMOVAL

  return (
    <Box borderRadius='lg' backgroundColor='input.background'>
      {canRemovePmi && <CanRemovePmiDetails />}
      {!canRemovePmi && <CannotRemovePmiDetails ltcvPercent={ltcvPercent} />}
    </Box>
  )
}
